import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useSlots } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoadingError',
    props: {
        title: { type: String, required: false },
        buttonClass: { type: null, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const { t: $t } = useI18n();
        const slots = useSlots();
        const __returned__ = { $t, slots };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
